import { Injectable } from '@angular/core';
import { DsconfigService, RestConnService, StorageService } from '@services/services.module';
import { Observable } from 'rxjs';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';

// tslint:disable-next-line:class-name
export class datesData {
  public dateEnd: string;
  public dateInit: string;
  constructor() { }
}

// tslint:disable-next-line:class-name
export class DatesDataInd {
  public datesToLock: Array<string> = [];
  public employeeId: number;
  constructor() { }
}

@Injectable({
  providedIn: 'root'
})
export class BlockDayService {
  private dates: object;
  private calendar_data: object;

  constructor(
    private storage: StorageService,
    private dsConfig: DsconfigService,
    private _res: RestConnService,
    public calendar: NgbCalendar
  ) {
    this.calendar_data = {
      'calendar_data': dsConfig.getUrlBase() + '/ess/v1/calendar/lock'
    };
  }

  bloqDates(bloqDates: datesData): Observable<any> {
    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/calendar/lock/dates'
    };
    return this._res
      .post('dates', bloqDates,
        {
          collection: this.dates
        });
  }

  bloqDatesExt(bloqDates: datesData): Observable<any> {
    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/calendar/lock/external/dates'
    };
    return this._res
      .post('dates', bloqDates,
        {
          collection: this.dates
        });
  }

  bloqDatesInd(bloqDates: DatesDataInd): Observable<any> {
    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/employee/employees/calendar/lock'
    };
    return this._res
      .post('dates', bloqDates,
        {
          collection: this.dates
        });
  }

  getCalendarBloq(year: string, month: string, userId?: number): Observable<any> {
    if (this.storage.get('generalBlock')) {

      const dateMonth = this.calendar.getToday().month - 1;
      const str = '' + dateMonth;
      const pad = '00';
      const dateMonthStr = pad.substring(0, pad.length - str.length) + str;

      if (userId) {
        return this._res.get('calendar_data', { employeeId: userId, year: year, month: dateMonthStr },
          {
            collection: this.calendar_data
          }
        );
      } else {
        return this._res.get('calendar_data', { year: year, month: dateMonthStr },
          {
            collection: this.calendar_data
          }
        );
      }

    } else {
      this.storage.set('generalBlock', false);
      if (userId) {
        return this._res.get('calendar_data', { employeeId: userId, year: year, month: month },
          {
            collection: this.calendar_data
          }
        );
      } else {
        return this._res.get('calendar_data', { year: year, month: month },
          {
            collection: this.calendar_data
          }
        );
      }
    }
  }
}
